import {useContext, useState} from "react";
import {isCurrentPageDenyQuery, useStartApi} from "../services/api/ApiContext";
import {getUserProfile} from "../services/api/profileApi";
import {useOktaAuth} from "@okta/okta-react";
import {useLocation} from "react-use";

const {createContext} = require("react");

const profileContext = createContext(null);

const getUserProfileApiProcess = ({data}) => {
	if(data?.data && 'user' in data?.data) {
		delete data.data.user;
	}

	return data?.data;
}

export const ProfileProvider = ({children}) => {
	const {authState} = useOktaAuth();
	const location = useLocation();
	const [lastUpdate, forceUpdate] = useState(-1);
	const denyQuery = isCurrentPageDenyQuery(location)

	const {data} = useStartApi(['getProfile', lastUpdate, authState?.accessToken], getUserProfile, getUserProfileApiProcess, {
		enabled: !denyQuery && !!authState?.isAuthenticated && !!authState?.accessToken,
	});

	const refresh = () => forceUpdate(Date.now);

	const updateProfile = (profile) => refresh();

	return (
		<profileContext.Provider value={{
			data,
			refresh,
			updateProfile,
		}}>
			{children}
		</profileContext.Provider>
	);
}

export const useProfile = () => useContext(profileContext);
